import axios from 'axios';
import authService from '../services/auth.service';

console.log('url check', process.env.REACT_APP_API_BASE_URL)

const instance = axios.create({
    baseURL: process.env.REACT_APP_API_BASE_URL 
});

instance.interceptors.request.use((config) => {
    const authUser = authService.getAuthUser();
    console.log("USER", authUser)
    if (authUser) {
        config.headers['authorization'] = `Bearer ${authUser.token}`;
    }
    return config;
}, (error) => {
    if (typeof error.response === 'undefined') {
        console.log('CORS')
    }
    return Promise.resolve('error');
});

instance.interceptors.response.use((response) => {
    return response;
}, (error) => {
    if (error?.response?.status === 401) { 
        localStorage.removeItem('authUser');
        window.location.reload();
    } else {
        return Promise.reject(error.response);
    }
});

const get = (url, params, config = {}) => instance.get(url, { params, ...config });
const post = (url, data, config = {}) => instance.post(url, data, config);

const methods = { get, post };

export default methods;
